import { useParams } from "react-router-dom";
import { useAddTerminal } from "../hooks/TerminalHooks";
import { TerminalDTO } from "../types/terminalDTO";
import ValidationSummary from "../ValidationSummary";
import TerminalForm from "./TerminalForm";
import { toast } from 'react-toastify';
import { useState } from "react";
import { ClipLoader } from "react-spinners";
import { useTranslation } from 'react-i18next';

const UnitAdd = () => {
  const { t } = useTranslation();
  const createValidToDate = () => {
    const date = new Date();
    date.setFullYear(2099);
    date.setSeconds(0, 0);
    return date;
  };
  const { organisationId, unitId } = useParams<{ organisationId: string, unitId: string }>();
  if (!organisationId) throw new Error("Missing organisationId from params");
  if (!unitId) throw Error("Need a unit id");
  const [terminal, setTerminal] = useState<TerminalDTO>({
    id: "00000000-0000-0000-0000-000000000000",
    organisationId: organisationId,
    unitId: unitId,
    name: "",
    address: "",
    protocol: null,
    validFrom: new Date(new Date().setSeconds(0, 0)),
    validTo: createValidToDate(),
    lastModified: new Date(),
  });
  const addTerminalMutation = useAddTerminal(organisationId, unitId, setTerminal);

  return (
    <>
      {addTerminalMutation.isError && (
        <ValidationSummary error={addTerminalMutation.error} />
      )}
      {addTerminalMutation.isPending ? (
        <div className="spinner-container" style={{ textAlign: 'center', marginTop: '20px' }}>
          <ClipLoader size={50} color={"#123abc"} loading={true} />
          <p>{t('terminal.addWait')}</p>
        </div>
      ) : (
        <TerminalForm
          headerText={t('terminal.add')}
          terminal={terminal}
          submitted={(terminal) => addTerminalMutation.mutate(terminal,
            {
              onError: () => {
                toast.error(t('terminal.addError'));
              },
              onSuccess: () => {
                toast.success(t('terminal.addSuccess'));
                history.back();
              }
            }
          )}
        />
      )}
    </>
  );
};

export default UnitAdd;
